import React from "react";
import styles from "./Navigation.module.scss";
import { Link } from "react-router-dom";
import { IoIosArrowDown } from "react-icons/io";

const Navigation = () => {
  return (
    <nav>
      <ul className={styles.mainMenu}>
        <li className={styles.drop}>
          <Link to={process.env.PUBLIC_URL + "/"}>
            Home
          </Link>
        </li>
        <li className={styles.drop}>
          <a href={process.env.PUBLIC_URL + "/#plans"}>
            Plans
          </a>
        </li>
        <li>
          <Link to={process.env.PUBLIC_URL + "/services"}>Services</Link>
        </li>
        <li className={styles.drop}>
          <Link>
            About <IoIosArrowDown />
          </Link>
          <ul className={styles.dropdownMenu}>
            <li>
              <Link to={process.env.PUBLIC_URL + "/about"}>About Us</Link>
            </li>
            <li>
              <a
                href={process.env.PUBLIC_URL + "/#how-it-works"}
              >
                How It Works
              </a>
            </li>
            <li>
              <a href={process.env.PUBLIC_URL + "/#faqs"}>
                FAQs
              </a>
            </li>
            <li>
              <a href={process.env.PUBLIC_URL + "/#reviews"}>
                Reviews
              </a>
            </li>
          </ul>
        </li>
        <li>
          <Link to={process.env.PUBLIC_URL + "/contact"}>Contact</Link>
        </li>
        <li className={styles.drop}>
          <Link>
            Policies <IoIosArrowDown />
          </Link>
          <ul className={styles.dropdownMenu}>
            <li>
              <Link to={process.env.PUBLIC_URL + "/privacy-policy"}>Privacy Policy</Link>
            </li>
            <li>
              <Link
                to={process.env.PUBLIC_URL + "/refund-policy"}
              >
                Refund Policy
              </Link>
            </li>
            <li>
              <Link to={process.env.PUBLIC_URL + "/disclaimer"}>
                Disclaimer
              </Link>
            </li>
            <li>
              <Link to={process.env.PUBLIC_URL + "/terms-of-service"}>
                Terms of Service
              </Link>
            </li>
            <li>
              <Link to={process.env.PUBLIC_URL + "/tcpa-consent"}>
                TCPA Consent
              </Link>
            </li>
          </ul>
        </li>
      </ul>
    </nav>
  );
};

export default Navigation;
